import i from 'i18next'
import { motion } from 'framer-motion'
import useTranslations, { getTranslations } from 'lib/hooks/use-translations'
import { getMenu, getMenuCollections } from 'lib/hooks/use-collections'
import Layout from 'components/Layout'
import Title from 'components/Title'
import Header from 'components/sections/Header'
import TextImageHalf from 'components/sections/TextImageHalf'
import Footer from 'components/sections/Footer'
import TextImageFull from 'components/sections/TextImageFull'
import Collection from 'components/sections/Collection'

export async function getStaticProps() {
	const translations = await getTranslations({ page: 'story' })
	const nav = await getMenu()
	const collections = await getMenuCollections()
	return {
		props: { translations, nav, collections },
		revalidate: 21600,
	}
}

export default function Story({ loaded, translations, nav, collections }) {
	useTranslations( translations )

	return (
		<Layout loaded={loaded} nav={nav} collections={collections}>
			<Title page="story" />
			<Header
				title={i.t( 'story.hero' )}
				bigImage={i.t( 'story.images.1' )}
				smallImage={i.t( 'story.images.2' )}
			/>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 1 }}
			>
				<TextImageHalf
					align="left"
					image={i.t( 'story.images.3' )}
					text={i.t( 'story.intro', { postProcess: 'markdown-jsx' })}
				/>
				<TextImageFull
					align="right"
					image={i.t( 'story.images.4' )}
					text={i.t( 'story.ingredients', { postProcess: 'markdown-jsx' })}
				/>
				{( collections[ 3 ] && <Collection collection={collections[ 3 ]} /> )}
				<TextImageHalf
					align="left top"
					title={i.t( 'story.packaging.title' )}
					text={i.t( 'story.packaging.1', { postProcess: 'markdown-jsx' })}
					image={i.t( 'story.images.5' ) }
				/>
				<TextImageHalf
					align="right"
					text={i.t( 'story.packaging.2', { postProcess: 'markdown-jsx' })}
					image={i.t( 'story.images.6' )}
				/>
				<TextImageFull
					align="left"
					text={i.t( 'story.blog', { postProcess: 'markdown-jsx' })}
					image={i.t( 'story.images.7' )}
				/>
			</motion.div>
			<Footer />
		</Layout>
	)
}
